









































































































































































































































































































































import { Mixins, Component, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';
import exceljs from 'exceljs';
import moment from 'moment';

import * as I from '@/interfaces';
import * as U from '@/utils';
import { error } from 'console';

class State {
  name: string;
  headers: unknown[];
  accessZoneCode: number;
  listDoor: I.DoorAuthSendData[];
  listGroup: I.DoorAuthSendData[];
  userType: string;
  listUserType: I.CodeData[];
  constructor() {
    this.name = '';
    this.accessZoneCode = 0;
    this.listDoor = [];
    this.listGroup = [];
    this.userType = '1';
    this.listUserType = [];
    this.headers = [
      { text: '메모', value: 'memo', align: 'start' },
      { text: '이름', value: 'user.name', align: 'start' },
      { text: '사원번호', value: 'user.empno', align: 'start' },
      { text: '카드번호', value: 'user.uid', align: 'start' },
      { text: '사업장', value: 'user.deptNameA', align: 'start' },
      { text: '회사', value: 'user.companyName', align: 'start' },
      { text: '부서', value: 'user.deptNameB', align: 'start' },
      { text: '직급', value: 'user.dutyNameA', align: 'start' },
      { text: '종료일', value: 'user.periodTo', align: 'start' },
      { text: '전화번호', value: 'user.telNo', align: 'start' },
      { text: '이메일', value: 'user.email', align: 'start' }
    ];
  }
}

enum ECodeType {
  ECompanyCode,
  EDeptCodeA,
  EDeptCodeB,
  EDutyCodeA
}

class CodeDialogState {
  show: boolean;
  title: string;
  items: I.CodeData[];
  selected: unknown;
  search: string;
  headers: unknown[];
  codeType: ECodeType;
  callback: Function;

  constructor() {
    this.show = false;
    this.title = '';
    this.items = [];
    this.search = '';
    this.headers = [];
    this.callback = async () => {};
    this.codeType = ECodeType.ECompanyCode;
  }
}

class DialogState<T extends I.DoorAuthSendData> {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: T[];
  headers: unknown[];
  items: T[];
  zoneCode: number;
  callback: Function;

  onAdd(list: T[]) {
    list.forEach(item => {
      this.selected.push(item);
    });
  }

  onRemove(list: T[]) {
    list.forEach(item => {
      const find = this.selected.find(x => x.code === item.code);
      if (find) {
        const idx = this.selected.indexOf(find);
        if (idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    });
  }

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.zoneCode = 0;
    this.callback = async () => {};
  }
}

@Component
export default class ExcelUser extends Mixins(AxPage) {
  state: State = new State();
  listUser: I.ExcelUserData[] = [];
  pageInfo: I.ExcelUserPageInfo | undefined;
  codeDialogState = new CodeDialogState();
  dialogState = new DialogState();
  tabZone = 0;

  @Ref()
  fileUpload!: HTMLInputElement;

  async prepare() {
    const baseData = await this.getBaseData();
    if (baseData) {
      this.pageInfo = baseData;
      const list = this.getZoneList();
      if (list) {
        this.state.accessZoneCode = list[0].code;
      }
      this.state.listUserType = this.pageInfo.listUserType;
    }
  }

  async getBaseData() {
    const result = await this.API.call.excel.userPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  TabZoneChange(value: number) {
    const list = this.getZoneList();
    if (list) {
      this.state.accessZoneCode = list[value].code;
    }
  }

  clickUpload() {
    console.log('click upload');
    this.fileUpload.click();
  }

  ClickDownload() {
    console.log('click download');
    this.onExportExcel('사용자 등록 양식');
  }

  async onExportExcel(prefix: string) {
    try {
      const colNames = (n: number) => {
        const ordA = 'A'.charCodeAt(0);
        const ordZ = 'Z'.charCodeAt(0);
        const len = ordZ - ordA + 1;

        let s = '';
        while (n >= 0) {
          s = String.fromCharCode((n % len) + ordA) + s;
          n = Math.floor(n / len) - 1;
        }
        return s;
      };

      moment.locale('ko');
      const momentTime = moment(Date.now());

      const workbook = new exceljs.Workbook();
      const worksheet = workbook.addWorksheet('sheet', { properties: { defaultColWidth: 10 } });
      // 헤더 작성 (식수 조회 [사원별] 등등..)
      worksheet.getCell('A1').value = '메모';
      worksheet.getCell('B1').value = '이름';
      worksheet.getCell('C1').value = '사원번호';
      worksheet.getCell('D1').value = '카드번호';
      worksheet.getCell('E1').value = '사업장';
      worksheet.getCell('F1').value = '회사';
      worksheet.getCell('G1').value = '부서';
      worksheet.getCell('H1').value = '직급';
      worksheet.getCell('I1').value = '종료일';
      worksheet.getCell('J1').value = '전화번호';
      worksheet.getCell('K1').value = '이메일';

      worksheet.getCell('A2').value = '';
      worksheet.getCell('B2').value = '홍길동';
      worksheet.getCell('C2').value = '20200101';
      worksheet.getCell('D2').value = '107091190';
      worksheet.getCell('E2').value = '서울';
      worksheet.getCell('F2').value = '회사이름';
      worksheet.getCell('G2').value = '부서이름';
      worksheet.getCell('H2').value = '직급이름';
      worksheet.getCell('I2').value = '2050-12-31';
      worksheet.getCell('J2').value = '010-1234-1234';
      worksheet.getCell('K2').value = 'abc@def.com';

      // 엑셀 파일을 저장한다
      const xls64 = await workbook.xlsx.writeBuffer();
      const a = document.createElement('a');
      const data = new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      const url = URL.createObjectURL(data);
      a.href = url;
      a.download = prefix + momentTime.format('YYYY-MM-DD-HH-mm-ss') + '.xlsx';
      document.body.appendChild(a);
      a.click();
      setTimeout(function() {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 0);
    } catch (e) {
      await this.showErrorModal('엑셀 내보내기 오류', e.message);
    }
    this.setLoading(false);
  }

  async changeFile() {
    console.log('change file');
    if (this.fileUpload.files) {
      this.listUser = [];
      const file = this.fileUpload.files[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      const result = await this.API.call.excel.userRead(formData);
      console.log(result);
      if (result instanceof Error) {
        await this.handleError(result);
        return false;
      } else {
        this.listUser = result.data;
      }
    }
  }

  async CheckSave() {
    const listUser: I.User[] = [];
    this.listUser.forEach(user => {
      if (user.memo === '') {
        listUser.push(user.user);
      }
    });
    if (listUser.length === 0) {
      const result = await this.showConfirmModal(
        '오류',
        '저장할 데이터가 없습니다.. <br /> 확인요망',
        ['네']
      );
      return;
    }
    if (this.state.listDoor.length === 0 && this.state.listGroup.length === 0) {
      const result = await this.showConfirmModal(
        '오류',
        '출입문을 선택해 주세요. <br /> 확인요망',
        ['네']
      );
      return;
    }

    await this.SaveUser();
  }

  async SaveUser() {
    const listUser: I.User[] = [];
    this.listUser.forEach(user => {
      if (user.memo === '') {
        listUser.push(user.user);
      }
    });
    this.setLoading(true);
    const result = this.API.call.excel.userSave({
      //일괄 저장 후 메시지, 리스트 처리 필요
      listUser: listUser,
      listDoor: this.state.listDoor,
      listGroup: this.state.listGroup,
      userType: parseInt(this.state.userType)
    });
    if (result instanceof Error) {
      await this.handleError(result);
    } else {
      await this.showErrorModal('알림', '저장되었습니다.');
    }
    this.setLoading(false);
  }

  async ClickSave() {
    this.CheckSave();
  }

  showCompanySelectDialog(companyName: string) {
    return;
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '회사 검색',
      param: {
        items: this.pageInfo.listCompanyCode,
        selected: [],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            const codeData = selected[0];
            this.listUser.forEach(user => {
              if (user.user.companyName === companyName) {
                user.user.companyCode = codeData.code;
                user.user.companyName = codeData.name;
                user.isCompany = true;
              }
            });
          }
        }
      },
      single: true
    });
  }

  showDeptCodeASelectDialog(deptNameA: string) {
    return;
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '사업장 검색',
      param: {
        items: this.pageInfo.listDeptCodeA,
        selected: [],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            const codeData = selected[0];
            this.listUser.forEach(user => {
              if (user.user.deptNameA === deptNameA) {
                user.user.deptCodeA = codeData.code;
                user.user.deptNameA = codeData.name;
                user.isCompany = true;
              }
            });
          }
        }
      },
      single: true
    });
  }

  showDeptCodeBselectDialog(dpetNameB: string) {
    return;
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '부서 검색',
      param: {
        items: this.pageInfo.listDeptCodeB,
        selected: [],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            const codeData = selected[0];
            this.listUser.forEach(user => {
              if (user.user.deptNameB === dpetNameB) {
                user.user.deptCodeB = codeData.code;
                user.user.deptNameB = codeData.name;
                user.isCompany = true;
              }
            });
          }
        }
      },
      single: true
    });
  }

  showDutyCodeASelectDialog(dutyNameA: string) {
    return;
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '직급 검색',
      param: {
        items: this.pageInfo.listDutyCodeA,
        selected: [],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            const codeData = selected[0];
            this.listUser.forEach(user => {
              if (user.user.dutyNameA === dutyNameA) {
                user.user.dutyCodeA = codeData.code;
                user.user.dutyNameA = codeData.name;
                user.isCompany = true;
              }
            });
          }
        }
      },
      single: true
    });
  }

  ClickOpenGroupPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllGroup = this.pageInfo?.listGroup.filter(
      x => x.zoneCode === this.state.accessZoneCode
    );
    console.log(listAllGroup);
    if (!listAllGroup) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listGroup.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listGroup = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllDoor = this.pageInfo?.listDoor.filter(
      x => x.zoneCode === this.state.accessZoneCode
    );
    if (!listAllDoor) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listDoor.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listDoor = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  onAdd(list: I.DoorAuthSendData[]) {
    this.dialogState.onAdd(list);
  }

  onRemove(list: I.DoorAuthSendData[]) {
    this.dialogState.onRemove(list);
  }

  ClickDoorSave() {
    this.dialogState.show = false;
    this.state.listDoor = [];
    this.dialogState.selected.forEach(item => {
      this.state.listDoor.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }

  ClickGroupSave() {
    this.dialogState.show = false;
    this.state.listGroup = [];
    this.dialogState.selected.forEach(item => {
      this.state.listGroup.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }
}
